module.exports = __webpack_public_path__ + "img/filters_jp.9d3fbc9.jpg";